jQuery(document).ready(function() {
  // collapsible section
      $(document).on("click",".collapsible-section .collapse-item .collapse-title",function(e){
        e.preventDefault();
        $(this).parents(".collapse-item").siblings().find(".collapse-content").slideUp();
        $(this).parents(".collapse-item").siblings().removeClass("active");
        $(this).parents(".collapse-item").addClass("active");
        $(this).parents(".collapse-item").find(".collapse-content").slideToggle();

        console.log("SHOULD BE REMOVING DISPLAY NONE")

        if($(this).parents(".collapse-item").hasClass("reviews")){
          $('.collapsible-section .reviews-wrapper').slick("unslick");
          reviewSliderCollaps();
        }
      });


  $(document).on("click",".faqs-with-images .collapse-item .collapse-title",function(e){
        e.preventDefault();
        $(this).parents(".collapse-item").siblings().find(".collapse-content").slideUp();
        $(this).parents(".collapse-item").siblings().removeClass("active");
        $(this).parents(".collapse-item").addClass("active");
        $(this).parents(".collapse-item").find(".collapse-content").slideToggle();
        
        if($(this).parents(".collapse-item").hasClass("reviews")){
          $('.faqs-with-images .reviews-wrapper').slick("unslick");
          reviewSliderCollaps();
        }
  });

  // collapsible review slider
      function reviewSliderCollaps(){
        $('.collapsible-section .reviews-wrapper').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: $('.c-review-prev'),
          nextArrow: $('.c-review-next'),
          dots: true,
          appendDots: '.c-reviews-dot',
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
                arrows: true
              }
            }
          ]
        });
      }
      reviewSliderCollaps();
  
  jQuery(".blog-page-content .blog-content-listing .blog-content-listing-title").click(function(){
    jQuery("body").addClass("content-open");
  });

  jQuery("body .blog-content-listing-drawer.for-mobile .toggle-icon").click(function(){
    jQuery("body").removeClass("content-open");
  });
  jQuery(".blog-content-listing-drawer.for-mobile ul li a").click(function(){
    jQuery("body").removeClass("content-open");
  });

  // FAQS
  let title = document.querySelectorAll(".faqs-wrapper .title-block");
  title.forEach((qsitem) => {
    qsitem.addEventListener("click", function (e) {
      //   store the .answer div containing the answer
      let sibling = qsitem.nextElementSibling;
      // Nested loop for removing active class from all and set answer height to 0
      title.forEach((item) => {
        item.nextElementSibling.style.height = "0px";
        //   remove class "active" except for the currently clicked item
        item != qsitem && item.parentNode.classList.remove("active");
      });
      //then toggle the "active" class of clicked item's parent ".qna"
      this.parentNode.classList.toggle("active");
  
      // set actual height for .answer div if .qna has the class "active"
      if (qsitem.parentNode.classList.contains("active")) {
        sibling.style.height = sibling.scrollHeight + "px";
      } else {
        sibling.style.height = "0px";
      }
    });
  });

  // template -- PRODUCT
  if(document.body.classList.contains("template-product")){
      jQuery('.product-media-slider .main-images').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $('.product-prev'),
        nextArrow: $('.product-next'),
        dots: true,
        appendDots: '.product-dots',
        asNavFor: '.product-media-slider .thumbnail-images',
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              arrows: true
            }
          }
        ]
      });
      jQuery('.product-media-slider .thumbnail-images').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.product-media-slider .main-images',
        dots: false,
        focusOnSelect: true,
        arrows: false
      });
  
      // pdp descript read more btn
      let readMore = document.querySelector("[data-desc-more-info]") || null;
      if(readMore){
        readMore.addEventListener("click",function(e){
          e.preventDefault();
          document.querySelector("[data-product-description]").classList.toggle("read-more");
        });
      }

      // stickybar
      document.addEventListener("scroll",debounce((event) => {
        console.log("scrollled");
        let ele = document.querySelector(".full-width-video-section.pdp-page");
        let top = document.querySelector(".full-width-video-section.pdp-page").offsetTop;
        if(window.scrollY > (top + ele.offsetHeight)){
          // console.log("adadClass");
          document.body.classList.add("pro-stickybar-active")
        }else{
          // console.log("remove adadClass");
          document.body.classList.remove("pro-stickybar-active")
        }
      }, 200));
      // sticky add to cart btn
      let stickyA2c = document.querySelector("[data-pro-sticky-a2c-btn]") || null;
      if(stickyA2c){
        stickyA2c.addEventListener("click",function(e){
          e.preventDefault();
          document.querySelector(".product-form__submit").click();
        });
      }
  
      // data-pro-tab-btn
      $(document).on("click","[data-pro-tab-btn]",function(e){
        e.preventDefault();
        $(this).parents(".nav-tabs").find("a.active").removeClass("active");
        $(this).addClass("active");
        $(".tabs-content .tab.active").removeClass("active");
        $(`.tabs-content #${$(this).attr("data-id")}`).addClass("active");
      });
  
      // collapsible review slider
      function reviewSliderCollaps(){
        $('.collapsible-section .reviews-wrapper').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: $('.c-review-prev'),
          nextArrow: $('.c-review-next'),
          dots: true,
          appendDots: '.c-reviews-dot',
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
                arrows: true
              }
            }
          ]
        });
      }
      reviewSliderCollaps();
      
  
      //resource video play/pause
      let vidPlayArea = document.querySelector("[data-resource-video-play-area]") || null;
      if(vidPlayArea){
        vidPlayArea.addEventListener("click",function(e){
          e.preventDefault();
          this.closest("[data-resource-video]").classList.add("active");
          this.closest("[data-resource-video]").querySelector("video").play();
        });
      }
  };
  // PDP temp end

  //contact page
  if (document.body.classList.contains("template-contact") || document.body.classList.contains("template-business-homepage")) {
    // data-contact-custom-select-title
    let titles = document.querySelectorAll("[data-contact-custom-select-title]");
    titles.forEach(title => {
      title.addEventListener("click", function(e) {
        e.preventDefault();
        let formSelectInput = this.closest("[data-form-select-input]");
        formSelectInput.classList.toggle("active");
      });
    });
    let customOptions = document.querySelectorAll("[data-contact-custom-select-item]") || null;
    if(customOptions.length > 0){
      customOptions.forEach(item => {
        item.addEventListener("click",function(e){
          e.preventDefault();
          this.closest("[data-form-select-input]").classList.remove("active");
          this.closest("[data-form-select-input]").querySelector("[data-contact-custom-select-title]").innerHTML = this.dataset.value;
          let option = this.closest("[data-form-select-input]").querySelector(`select option[value="${this.dataset.value}"]`);
          // console.log("option",option,this.dataset.value);
          // if(this.dataset.id != option.closest("select").querySelector("option[selected]").id){
            if(option.closest("select").querySelector("option[selected]")) option.closest("select").querySelector("option[selected]").removeAttribute("selected");
            option.setAttribute("selected","selected");

            // trigger original select box value
            const evt = new Event("change");
            const element = option.closest("select");
            element.dispatchEvent(evt);
          // }
        });
      });
    }
  }

  // jQuery('.trade-show-tabs-section .tab-content-block.upcoming .wrapper').slick({
  //   infinite: true,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   prevArrow: $('.tsu-review-prev'),
  //   nextArrow: $('.tsu-review-next'),
  //   dots: true,
  //   appendDots: '.tsu-reviews-dot',
  // });
  // jQuery('.trade-show-tabs-section .tab-content-block.past .wrapper').slick({
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   prevArrow: $('.tsp-review-prev'),
  //   nextArrow: $('.tsp-review-next'),
  //   dots: true,
  //   appendDots: '.tsp-reviews-dot',
  // });
});